import React, { useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogTitle, DialogContent, TextField } from '@material-ui/core';
import Rest from '../../../../helpers/Rest';
import { useDocuments } from './DocumentsContext';

function dataUrlToBase64(url){
    return url.substring(url.indexOf(',') + 1)
}

function TitleDialog({file, open, onClose, onSave}){
    const [title, setTitle] = React.useState("")

    useEffect(() => {
        setTitle(file ? file.name.replace(/\.[^.]+$/, "") : "")
    }, [file])

    return <Dialog open={open} onClose={onClose}>
        <DialogTitle>Upload document</DialogTitle>
        <DialogContent style={{minWidth:300}}>
            <TextField
                variant="outlined"
                size="small"
                label="Label"
                value={title}
                onChange={e => setTitle(e.target.value)}
                fullWidth
            />
        </DialogContent>
        <DialogActions>
            <Button variant="text" onClick={onClose}>Cancel</Button>
            <Button variant="contained" color="primary" onClick={() => onSave(title)}>Save</Button>
        </DialogActions>
    </Dialog>
}

export default function({deviceId}){
    const ref = React.useRef(null)

    const [file, setFile] = React.useState(null)
    const {documents, setDocuments} = useDocuments()

    return <><Button
        variant="text"
        color="primary"
        onClick={() => ref.current.click()}
    >
        Upload file
        <input type="file" ref={ref} style={{display: "none"}} onChange={() => {
            const files = ref.current.files
            setFile(files && files[0] || null)
            ref.current.value = ""
        }}/>
    </Button>
    <TitleDialog file={file} open={!!file} onClose={() => setFile(null)} onSave={title => {
            const reader = new FileReader()
            reader.onload = () => {
                const data = dataUrlToBase64(reader.result)
                const doc = {
                    title: title,
                    file_name: file.name,
                    mime_type: file.type,
                    base64_data: data
                }
                Rest.post(`documents/${deviceId}`, doc).then(document => {
                    setDocuments([...(documents || []), document])
                })
                setFile(null)
            }
            reader.readAsDataURL(file)
        }}/>
    </>
}